export default __webpack_public_path__ + "static/media/epostal3.1f44e754.jpg";